import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { updateEvent } from '../../../../store/actions/achievementActions'
import axios from 'axios'

const AchievementEventEdit = () => {
  const [name, setname] = useState('')

  const dispatch = useDispatch()
  const history = useHistory()

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateEvent(history, id, name))
  }

  useEffect(() => {
    if (!userInfo || !userInfo.permission) return;
    if (!userInfo.user.roles[0].name == "Super Admin") window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
  }, []);

  const id = localStorage.getItem("id_achievement_event");
  
  useEffect(async () => {
    let {data} = await axios.get(`achievements/editEvent/${id}`)
    setname(data.data.name)
  }, [id])

  const dataLogin = useSelector((state) => state.login);
  let { userInfo } = dataLogin;

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Edit Event</h3>
        </div>
      </div>
      <div className="clearfix"></div><br/>
      <div className="row">
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <h2>Form Input</h2>
              <div className="clearfix"></div>
            </div>
            
            <div className="x_content">  
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="form-group">
                  <label for="name">Name</label>
                  <input type="text" 
                    className='form-control'
                    name="name" 
                    required 
                    value={name}
                    onChange={(e) => setname(e.target.value)} />
                    
                </div>
                <button type="submit" className="btn btn-primary pull-right">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AchievementEventEdit
